{
  "growth-starburst.jira-issue-view-twc-spotlight-card.create-content.description": [
    {
      "type": 0,
      "value": "Try summarizing or generating more content with AI. You can always come back to this panel."
    }
  ],
  "growth-starburst.jira-issue-view-twc-spotlight-card.create-content.title": [
    {
      "type": 0,
      "value": "Now it's your turn!"
    }
  ],
  "growth-starburst.jira-issue-view-twc-spotlight-card.documentation.description": [
    {
      "type": 0,
      "value": "Create docs directly in Jira to capture work, strategy, and more — with AI doing the heavy lifting."
    }
  ],
  "growth-starburst.jira-issue-view-twc-spotlight-card.documentation.title": [
    {
      "type": 0,
      "value": "Turn ideas into docs instantly with AI"
    }
  ],
  "growth-starburst.jira-issue-view-twc-spotlight-card.interactive-video.description": [
    {
      "type": 0,
      "value": "Create video messages using Loom to talk through updates, feedback, or upcoming work."
    }
  ],
  "growth-starburst.jira-issue-view-twc-spotlight-card.interactive-video.title": [
    {
      "type": 0,
      "value": "Record & share videos"
    }
  ],
  "growth-starburst.jira-issue-view-twc-spotlight-card.navigation.next": [
    {
      "type": 0,
      "value": "Explore"
    }
  ],
  "growth-starburst.jira-issue-view-twc-spotlight-card.navigation.progress": [
    {
      "type": 1,
      "value": "currentStep"
    },
    {
      "type": 0,
      "value": "/"
    },
    {
      "type": 1,
      "value": "totalSteps"
    }
  ],
  "growth-starburst.jira-issue-view-twc-spotlight-card.navigation.skip": [
    {
      "type": 0,
      "value": "Dismiss"
    }
  ],
  "growth-starburst.jira-issue-view-twc-spotlight-tour.test-message.auto-advance-enabled": [
    {
      "type": 0,
      "value": "enabled"
    }
  ],
  "growth-starburst.jira-issue-view-twc-spotlight-tour.test-message.auto-advance-label": [
    {
      "type": 0,
      "value": "Auto advance:"
    }
  ],
  "growth-starburst.jira-issue-view-twc-spotlight-tour.test-message.dismiss-button": [
    {
      "type": 0,
      "value": "Dismiss Tour"
    }
  ],
  "growth-starburst.jira-issue-view-twc-spotlight-tour.test-message.start-from-step-label": [
    {
      "type": 0,
      "value": "Start from step:"
    }
  ],
  "growth-starburst.jira-issue-view-twc-spotlight-tour.test-message.steps-label": [
    {
      "type": 0,
      "value": "Steps:"
    }
  ],
  "growth-starburst.jira-issue-view-twc-spotlight-tour.test-message.title": [
    {
      "type": 0,
      "value": "TWC Spotlight Tour Test"
    }
  ],
  "growth-starburst.twc-admin-welcome-email.message-template.email.body.button-text": [
    {
      "type": 0,
      "value": "Create it in Jira"
    }
  ],
  "growth-starburst.twc-admin-welcome-email.message-template.email.body.main-image.alt-text": [
    {
      "type": 0,
      "value": "Invite your teammates to Jira"
    }
  ],
  "growth-starburst.twc-admin-welcome-email.message-template.email.invite-nudge.header": [
    {
      "type": 0,
      "value": "Welcome, "
    },
    {
      "type": 1,
      "value": "firstName"
    },
    {
      "type": 0,
      "value": "!"
    },
    {
      "type": 1,
      "value": "break"
    },
    {
      "type": 0,
      "value": " Let’s start with the Jira basics"
    }
  ],
  "growth-starburst.twc-admin-welcome-email.message-template.email.invite-nudge.steps-1.description": [
    {
      "type": 0,
      "value": "Create "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "tasks"
        }
      ],
      "type": 8,
      "value": "strong"
    },
    {
      "type": 0,
      "value": ", as chunks of work (just like to-dos) that you can break down into smaller, more achievable bits."
    }
  ],
  "growth-starburst.twc-admin-welcome-email.message-template.email.invite-nudge.steps-1.title": [
    {
      "type": 0,
      "value": "Break down your work"
    }
  ],
  "growth-starburst.twc-admin-welcome-email.message-template.email.invite-nudge.steps-2.description": [
    {
      "type": 0,
      "value": "Add "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "fields"
        }
      ],
      "type": 8,
      "value": "strong"
    },
    {
      "type": 0,
      "value": " to link all the important details to your issues, like due dates, assignees, priority & more."
    }
  ],
  "growth-starburst.twc-admin-welcome-email.message-template.email.invite-nudge.steps-2.title": [
    {
      "type": 0,
      "value": "Link important details"
    }
  ],
  "growth-starburst.twc-admin-welcome-email.message-template.email.invite-nudge.steps-3.description": [
    {
      "type": 0,
      "value": "Use a "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "board"
        }
      ],
      "type": 8,
      "value": "strong"
    },
    {
      "type": 0,
      "value": " or "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "list"
        }
      ],
      "type": 8,
      "value": "strong"
    },
    {
      "type": 0,
      "value": " to arrange issues in columns, or plot work out on a "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "timeline"
        }
      ],
      "type": 8,
      "value": "strong"
    },
    {
      "type": 0,
      "value": " or "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "calendar"
        }
      ],
      "type": 8,
      "value": "strong"
    },
    {
      "type": 0,
      "value": " over months or quarters."
    }
  ],
  "growth-starburst.twc-admin-welcome-email.message-template.email.invite-nudge.steps-3.title": [
    {
      "type": 0,
      "value": "View it your way"
    }
  ],
  "growth-starburst.twc-admin-welcome-email.message-template.email.invite-nudge.steps-header": [
    {
      "type": 0,
      "value": "Smash any project in 3 easy steps:"
    }
  ],
  "growth-starburst.twc-admin-welcome-email.message-template.email.invite-nudge.steps-header-closing-description": [
    {
      "type": 0,
      "value": "Jump into Jira to discover what’s possible."
    }
  ],
  "growth-starburst.twc-admin-welcome-email.message-template.email.invite-nudge.steps-header-closing-title": [
    {
      "type": 0,
      "value": "Ready to get started?"
    }
  ],
  "growth-starburst.twc-admin-welcome-email.message-template.email.invite-nudge.subtext": [
    {
      "type": 0,
      "value": "Over the next week, we’ll send you a series of Jira quick tips & resources to kickstart your project with ease."
    }
  ],
  "growth-starburst.twc-admin-welcome-email.message-template.email.subject.no-translate": [
    {
      "type": 0,
      "value": "TWC Welcome Email - "
    },
    {
      "type": 1,
      "value": "env"
    }
  ],
  "growth-starburst.twc-end-user-welcome-email.message-template.email.body.button-text": [
    {
      "type": 0,
      "value": "Create it in Jira"
    }
  ],
  "growth-starburst.twc-end-user-welcome-email.message-template.email.body.main-image.alt-text": [
    {
      "type": 0,
      "value": "Invite your teammates to Jira"
    }
  ],
  "growth-starburst.twc-end-user-welcome-email.message-template.email.invite-nudge.header": [
    {
      "type": 0,
      "value": "Welcome, "
    },
    {
      "type": 1,
      "value": "firstName"
    },
    {
      "type": 0,
      "value": "!"
    },
    {
      "type": 1,
      "value": "break"
    },
    {
      "type": 0,
      "value": " Let’s start with the Jira basics"
    }
  ],
  "growth-starburst.twc-end-user-welcome-email.message-template.email.invite-nudge.steps-1.description": [
    {
      "type": 0,
      "value": "Create "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "tasks"
        }
      ],
      "type": 8,
      "value": "strong"
    },
    {
      "type": 0,
      "value": ", as chunks of work (just like to-dos) that you can break down into smaller, more achievable bits."
    }
  ],
  "growth-starburst.twc-end-user-welcome-email.message-template.email.invite-nudge.steps-1.title": [
    {
      "type": 0,
      "value": "Break down your work"
    }
  ],
  "growth-starburst.twc-end-user-welcome-email.message-template.email.invite-nudge.steps-2.description": [
    {
      "type": 0,
      "value": "Add "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "fields"
        }
      ],
      "type": 8,
      "value": "strong"
    },
    {
      "type": 0,
      "value": " to link all the important details to your issues, like due dates, assignees, priority & more."
    }
  ],
  "growth-starburst.twc-end-user-welcome-email.message-template.email.invite-nudge.steps-2.title": [
    {
      "type": 0,
      "value": "Link important details"
    }
  ],
  "growth-starburst.twc-end-user-welcome-email.message-template.email.invite-nudge.steps-3.description": [
    {
      "type": 0,
      "value": "Use a "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "board"
        }
      ],
      "type": 8,
      "value": "strong"
    },
    {
      "type": 0,
      "value": " or "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "list"
        }
      ],
      "type": 8,
      "value": "strong"
    },
    {
      "type": 0,
      "value": " to arrange issues in columns, or plot work out on a "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "timeline"
        }
      ],
      "type": 8,
      "value": "strong"
    },
    {
      "type": 0,
      "value": " or "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "calendar"
        }
      ],
      "type": 8,
      "value": "strong"
    },
    {
      "type": 0,
      "value": " over months or quarters."
    }
  ],
  "growth-starburst.twc-end-user-welcome-email.message-template.email.invite-nudge.steps-3.title": [
    {
      "type": 0,
      "value": "View it your way"
    }
  ],
  "growth-starburst.twc-end-user-welcome-email.message-template.email.invite-nudge.steps-header": [
    {
      "type": 0,
      "value": "Smash any project in 3 easy steps:"
    }
  ],
  "growth-starburst.twc-end-user-welcome-email.message-template.email.invite-nudge.steps-header-closing-description": [
    {
      "type": 0,
      "value": "Jump into Jira to discover what’s possible."
    }
  ],
  "growth-starburst.twc-end-user-welcome-email.message-template.email.invite-nudge.steps-header-closing-title": [
    {
      "type": 0,
      "value": "Ready to get started?"
    }
  ],
  "growth-starburst.twc-end-user-welcome-email.message-template.email.invite-nudge.subtext": [
    {
      "type": 0,
      "value": "Over the next week, we’ll send you a series of Jira quick tips & resources to kickstart your project with ease."
    }
  ],
  "growth-starburst.twc-end-user-welcome-email.message-template.email.subject.no-translate": [
    {
      "type": 0,
      "value": "TWC Welcome Email - "
    },
    {
      "type": 1,
      "value": "env"
    }
  ],
  "growth-starburst.twc-onboarding-email-1.message-template.email.go-to-jira.button-text": [
    {
      "type": 0,
      "value": "Create it in Jira"
    }
  ],
  "growth-starburst.twc-onboarding-email-1.message-template.email.invite-nudge.header": [
    {
      "type": 0,
      "value": "Get all your work done in Jira"
    }
  ],
  "growth-starburst.twc-onboarding-email-1.message-template.email.invite-nudge.main-image.alt-text": [
    {
      "type": 0,
      "value": "Invite your teammates to Jira"
    }
  ],
  "growth-starburst.twc-onboarding-email-1.message-template.email.invite-nudge.steps-1.description": [
    {
      "type": 0,
      "value": "Got writer’s block on how to describe what your work? Use Rovo AI for Jira to generate ideas on the fly."
    }
  ],
  "growth-starburst.twc-onboarding-email-1.message-template.email.invite-nudge.steps-1.title": [
    {
      "type": 0,
      "value": "Brainstorm with AI"
    }
  ],
  "growth-starburst.twc-onboarding-email-1.message-template.email.invite-nudge.steps-2.description": [
    {
      "type": 0,
      "value": "Add "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "subtasks"
        }
      ],
      "type": 8,
      "value": "strong"
    },
    {
      "type": 0,
      "value": " to larger pieces of work to keep track of all the details. Better yet, AI can auto-suggest subtasks for you!"
    }
  ],
  "growth-starburst.twc-onboarding-email-1.message-template.email.invite-nudge.steps-2.title": [
    {
      "type": 0,
      "value": "Break it down"
    }
  ],
  "growth-starburst.twc-onboarding-email-1.message-template.email.invite-nudge.steps-3.description": [
    {
      "type": 0,
      "value": "Tag teammates in tasks with "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "@mentions"
        }
      ],
      "type": 8,
      "value": "strong"
    },
    {
      "type": 0,
      "value": " to get their attention, and keep everyone updated when work progresses."
    }
  ],
  "growth-starburst.twc-onboarding-email-1.message-template.email.invite-nudge.steps-3.title": [
    {
      "type": 0,
      "value": "@Mention away!"
    }
  ],
  "growth-starburst.twc-onboarding-email-1.message-template.email.invite-nudge.steps-header": [
    {
      "type": 0,
      "value": "Time-saving tips with Jira tasks:"
    }
  ],
  "growth-starburst.twc-onboarding-email-1.message-template.email.invite-nudge.steps-header-closing-description": [
    {
      "type": 0,
      "value": "How to kickstart collaboration in Jira:"
    }
  ],
  "growth-starburst.twc-onboarding-email-1.message-template.email.invite-nudge.steps-header-closing-title": [
    {
      "type": 0,
      "value": "How to kickstart collaboration in Jira:"
    }
  ],
  "growth-starburst.twc-onboarding-email-1.message-template.email.invite-nudge.subtext": [
    {
      "type": 0,
      "value": "Create work to track anything in Jira, from daily to-dos, to big projects and initiatives."
    }
  ],
  "growth-starburst.twc-onboarding-email-1.message-template.email.subject.no-translate": [
    {
      "type": 0,
      "value": "TWC Onboarding Email 1 - "
    },
    {
      "type": 1,
      "value": "env"
    }
  ],
  "growth-starburst.twc-onboarding-email-2.message-template.email.go-to-jira.button-text": [
    {
      "type": 0,
      "value": "Invite your teammates"
    }
  ],
  "growth-starburst.twc-onboarding-email-2.message-template.email.invite-nudge.closing-description": [
    {
      "type": 0,
      "value": "Invite your team to your project today."
    }
  ],
  "growth-starburst.twc-onboarding-email-2.message-template.email.invite-nudge.closing-title": [
    {
      "type": 0,
      "value": "Jira’s better with everyone together"
    }
  ],
  "growth-starburst.twc-onboarding-email-2.message-template.email.invite-nudge.header": [
    {
      "type": 0,
      "value": "Your teammates await! Let’s collaborate"
    }
  ],
  "growth-starburst.twc-onboarding-email-2.message-template.email.invite-nudge.main-image.alt-text": [
    {
      "type": 0,
      "value": "Invite your teammates to Jira"
    }
  ],
  "growth-starburst.twc-onboarding-email-2.message-template.email.invite-nudge.steps-1.description": [
    {
      "type": 0,
      "value": "The + icon on your board lets you quickly bring anyone on... well, on board!"
    }
  ],
  "growth-starburst.twc-onboarding-email-2.message-template.email.invite-nudge.steps-1.title": [
    {
      "type": 0,
      "value": "From your project"
    }
  ],
  "growth-starburst.twc-onboarding-email-2.message-template.email.invite-nudge.steps-2.description": [
    {
      "type": 0,
      "value": "@mention someone, or add them as an assignee to their work"
    }
  ],
  "growth-starburst.twc-onboarding-email-2.message-template.email.invite-nudge.steps-2.title": [
    {
      "type": 0,
      "value": "From tasks"
    }
  ],
  "growth-starburst.twc-onboarding-email-2.message-template.email.invite-nudge.steps-3.description": [
    {
      "type": 0,
      "value": "Access the Teams menu anywhere in Jira to add people from Slack, Microsoft, or Google"
    }
  ],
  "growth-starburst.twc-onboarding-email-2.message-template.email.invite-nudge.steps-3.title": [
    {
      "type": 0,
      "value": "From anywhere!"
    }
  ],
  "growth-starburst.twc-onboarding-email-2.message-template.email.invite-nudge.steps-header": [
    {
      "type": 0,
      "value": "Easy ways to invite your team:"
    }
  ],
  "growth-starburst.twc-onboarding-email-2.message-template.email.invite-nudge.subtext": [
    {
      "type": 0,
      "value": "Loop people in at just the right time in Jira - to keep everyone connected, collaborative & on the same page."
    }
  ],
  "growth-starburst.twc-onboarding-email-2.message-template.email.subject.no-translate": [
    {
      "type": 0,
      "value": "Post Office Test Message from "
    },
    {
      "type": 1,
      "value": "env"
    }
  ],
  "growth-starburst.twc-onboarding-email-3.message-template.email.go-to-jira.button-text": [
    {
      "type": 0,
      "value": "Try AI in Jira"
    }
  ],
  "growth-starburst.twc-onboarding-email-3.message-template.email.invite-nudge.header": [
    {
      "type": 0,
      "value": "Plan projects like a pro with Rovo AI"
    }
  ],
  "growth-starburst.twc-onboarding-email-3.message-template.email.invite-nudge.main-image.alt-text": [
    {
      "type": 0,
      "value": "Try AI in Jira"
    }
  ],
  "growth-starburst.twc-onboarding-email-3.message-template.email.invite-nudge.steps-1.description": [
    {
      "type": 0,
      "value": "When you just need the TLDR— Instantly summarize lengthy docs & info to get context on the fly"
    }
  ],
  "growth-starburst.twc-onboarding-email-3.message-template.email.invite-nudge.steps-1.title": [
    {
      "type": 0,
      "value": "Summarize in a snap"
    }
  ],
  "growth-starburst.twc-onboarding-email-3.message-template.email.invite-nudge.steps-2.description": [
    {
      "type": 0,
      "value": "AI brainstorms task descriptions for you, so you can focus on your most important, strategic work"
    }
  ],
  "growth-starburst.twc-onboarding-email-3.message-template.email.invite-nudge.steps-2.title": [
    {
      "type": 0,
      "value": "Cut out the busywork"
    }
  ],
  "growth-starburst.twc-onboarding-email-3.message-template.email.invite-nudge.steps-3.description": [
    {
      "type": 0,
      "value": "Not sure if you’ve captured everything? AI suggests how to break down your work, and then you’re free to adjust the details."
    }
  ],
  "growth-starburst.twc-onboarding-email-3.message-template.email.invite-nudge.steps-3.title": [
    {
      "type": 0,
      "value": "Get auto-magic task suggestions"
    }
  ],
  "growth-starburst.twc-onboarding-email-3.message-template.email.invite-nudge.steps-header": [
    {
      "type": 0,
      "value": "Time-saving, headache-reducing"
    },
    {
      "type": 1,
      "value": "lineBreak"
    },
    {
      "type": 0,
      "value": " AI tips:"
    }
  ],
  "growth-starburst.twc-onboarding-email-3.message-template.email.invite-nudge.steps-header-closing-description": [
    {
      "type": 0,
      "value": "Discover how Rovo AI in Jira can be your secret project management superpower."
    }
  ],
  "growth-starburst.twc-onboarding-email-3.message-template.email.invite-nudge.steps-header-closing-title": [
    {
      "type": 0,
      "value": "Take the productivity shortcut"
    }
  ],
  "growth-starburst.twc-onboarding-email-3.message-template.email.invite-nudge.subtext": [
    {
      "type": 0,
      "value": "Cut out repetitive work, focus on the big picture & save time with Rovo AI features in Jira."
    }
  ],
  "growth-starburst.twc-onboarding-email-3.message-template.email.subject.no-translate": [
    {
      "type": 0,
      "value": "Post Office Test Message from "
    },
    {
      "type": 1,
      "value": "env"
    }
  ],
  "jira-project-space-connected.message-templates.spotlight-description-couse": [
    {
      "type": 0,
      "value": "Create pages for your project without leaving Jira."
    }
  ],
  "jira-project-space-connected.message-templates.spotlight-description-xflow": [
    {
      "type": 0,
      "value": "Create Confluence pages within Jira. Free for 10 users."
    }
  ],
  "jira-project-space-connected.message-templates.spotlight-header-couse": [
    {
      "type": 0,
      "value": "Your project has Confluence pages"
    }
  ],
  "jira-project-space-connected.message-templates.spotlight-header-xflow": [
    {
      "type": 0,
      "value": "Add pages to your project"
    }
  ],
  "post-office.confluence-side-nav.next-best-action.1-on-1-loom-nudge.ad-controls.actions-done-so-far": [
    {
      "type": 0,
      "value": "What you’ve done so far in the product"
    }
  ],
  "post-office.confluence-side-nav.next-best-action.1-on-1-loom-nudge.ad-controls.recommendation-basis": [
    {
      "type": 0,
      "value": "This recommendation is based on:"
    }
  ],
  "post-office.confluence-side-nav.next-best-action.1-on-1-loom-nudge.ad-controls.suggestions": [
    {
      "type": 0,
      "value": "What we suggest to help you get the most value from Atlassian"
    }
  ],
  "post-office.confluence-side-nav.next-best-action.1-on-1-loom-nudge.ad-controls.why-am-i-seeing-this": [
    {
      "type": 0,
      "value": "Why am I seeing this?"
    }
  ],
  "post-office.confluence-side-nav.next-best-action.1-on-1-loom-nudge.body": [
    {
      "type": 0,
      "value": "Instead of manually typing 1-1 notes, why not try Loom to record meetings?"
    }
  ],
  "post-office.confluence-side-nav.next-best-action.1-on-1-loom-nudge.close": [
    {
      "type": 0,
      "value": "Close"
    }
  ],
  "post-office.confluence-side-nav.next-best-action.1-on-1-loom-nudge.cta": [
    {
      "type": 0,
      "value": "Try now"
    }
  ],
  "post-office.confluence-side-nav.next-best-action.1-on-1-loom-nudge.header": [
    {
      "type": 0,
      "value": "Automate meeting notes"
    }
  ],
  "post-office.confluence-side-nav.next-best-action.1-on-1-loom-nudge.image-alt": [
    {
      "type": 0,
      "value": "Notepad with sparkling background"
    }
  ]
}